// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"F4-z","subtitle":"G4-z","wrapper":"H4-z","leftArrow":"I4-z","rightArrow":"J4-z"};